webpackJsonp([11305920230724],{

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Sidebar = __webpack_require__(28);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	__webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageTemplateDetails = function (_React$Component) {
	  _inherits(PageTemplateDetails, _React$Component);
	
	  function PageTemplateDetails() {
	    _classCallCheck(this, PageTemplateDetails);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PageTemplateDetails.prototype.render = function render() {
	    var page = this.props.data.markdownRemark;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Sidebar2.default, this.props),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content__inner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'page' },
	            _react2.default.createElement('div', { className: 'page__body', dangerouslySetInnerHTML: { __html: page.html } })
	          )
	        )
	      )
	    );
	  };
	
	  return PageTemplateDetails;
	}(_react2.default.Component);
	
	exports.default = PageTemplateDetails;
	module.exports = exports['default'];

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PageTemplateDetails = __webpack_require__(85);
	
	var _PageTemplateDetails2 = _interopRequireDefault(_PageTemplateDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageTemplate = function (_React$Component) {
	  _inherits(PageTemplate, _React$Component);
	
	  function PageTemplate() {
	    _classCallCheck(this, PageTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PageTemplate.prototype.render = function render() {
	    var _props$data$site$site = this.props.data.site.siteMetadata,
	        title = _props$data$site$site.title,
	        subtitle = _props$data$site$site.subtitle;
	
	    var page = this.props.data.markdownRemark;
	    var _page$frontmatter = page.frontmatter,
	        pageTitle = _page$frontmatter.title,
	        pageDescription = _page$frontmatter.description;
	
	    var description = pageDescription !== null ? pageDescription : subtitle;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          pageTitle + ' - ' + title
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: description })
	      ),
	      _react2.default.createElement(_PageTemplateDetails2.default, this.props)
	    );
	  };
	
	  return PageTemplate;
	}(_react2.default.Component);
	
	exports.default = PageTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-template-jsx-8bb23bfa2cd73414d601.js